import { ErrorMessage } from "formik";
import CustomRadioInputProps from "../../services/models/customRadioInput.model";
import CustomText from "../atomic/CustomText";
import utils from "../../services/utils";
import CustomRadio from "../atomic/CustomRadio";

function CustomRadioInput({
  labelInfo,
  name,
  displayWhen,
  options,
  values,
  setFieldTouched,
  setFieldValue,
  manualFieldsChangeOnOptionClick,
}: CustomRadioInputProps): JSX.Element | null {
  if (!!displayWhen) {
    if (!utils?.displayHandler(displayWhen, values ?? {})) {
      return null;
    }
  }
  return (
    <div>
      {!!labelInfo.label && (
        <CustomText
          text={labelInfo.label}
          className={`inputLabel ${
            labelInfo.required
              ? "after:content-['*'] after:ml-1 after:text-requiredRed"
              : ""
          } `}
          fontWeight="font-semibold"
        />
      )}
      {options.map((option) => {
        if (!!option?.displayWhen)
          if (!utils.displayHandler(option?.displayWhen, values ?? {}))
            return null;

        return (
          <CustomRadio
            key={option.id + option.label}
            name={name}
            id={option?.id}
            label={option?.label}
            value={option?.value}
            manualFieldsChangeOnOptionClick={() =>
              manualFieldsChangeOnOptionClick?.(
                option,
                setFieldValue,
                setFieldTouched
              )
            }
          />
        );
      })}
      <ErrorMessage name={name}>
        {(msg) => <h6 className="text-xs text-requiredRed my-1">{msg}</h6>}
      </ErrorMessage>
    </div>
  );
}

export default CustomRadioInput;
